import { render, staticRenderFns } from "./ClientsAll.vue?vue&type=template&id=220a83e5&scoped=true&"
import script from "./ClientsAll.vue?vue&type=script&lang=ts&"
export * from "./ClientsAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220a83e5",
  null
  
)

export default component.exports